import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export const useNavigateToTemplate = () => {
  const navigate = useNavigate();

  const navigateToTemplate = useCallback(
    ({
      formData,
      action,
    }: {
      formData: any;
      action: 'delete' | 'create' | 'edit';
    }) => {
      navigate(
        `/create/templates/default/kaap-tenant-${action}?formData=${encodeURIComponent(
          JSON.stringify(formData),
        )}`,
      );
    },
    [navigate],
  );
  return navigateToTemplate;
};
